import { render } from "./VesDynWidget.vue?vue&type=template&id=e34f52d6&scoped=true&ts=true"
import script from "./VesDynWidget.vue?vue&type=script&lang=ts"
export * from "./VesDynWidget.vue?vue&type=script&lang=ts"

import "./VesDynWidget.vue?vue&type=style&index=0&id=e34f52d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e34f52d6"]])

export default __exports__